import React, { Component } from "react";
import Paper from "@mui/material/Paper";
import {
  FormControlLabel,
  CardHeader,
  CardContent,
  FormControl,
  Radio,
  Card,
  RadioGroup,
  FormLabel,
} from "@mui/material";
import "./css/InverterSelectorForm.css";

export class OutputVoltageView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //ovData only gets filled when user inputs data
      showNextButton: !(this.props.ovData === ""),
      outVoltData: this.props.ovData,
    };
  }

  saveOVData = (event) => {
    this.setState({ outVoltData: event.target.value });
    this.props.setOVData(event.target.value);
    //this.setState({showNextButton: true})

    if (this.props.data.ivData !== "") {
      this.props.showNextButton(true);
    } else {
      this.props.showNextButton(false);
    }
  };

  render() {
    return (
      //App starts here
      <Card>
        <CardHeader
          titleTypographyProps={{
            fontFamily: 'Ford-Normal',
          }}
          className="paperh-title"
          title={<h2>Output Voltage</h2>}
          subheader="Select Your Output Requirements"
        />
        <CardContent>
          {!this.props.singlePhase && (
            <Paper elevation={10}  style={{padding:10}}>
              <FormControl>
                <FormLabel style={{fontFamily: "Ford-Normal"}} id="demo-radio-buttons-group-label">
                  Note: The higher the voltage the smaller the wires and will be
                  more cost effective to wire.
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  onChange={this.saveOVData}
                  defaultValue={this.state.outVoltData}
                  sx={{ '& .MuiTypography-root': { fontFamily: 'Ford-Normal' } }}
                >
                  <FormControlLabel
                    value="120V, 1P"
                    control={<Radio />}
                    label="120V, 1P"
                  />
                  {this.props.totalcap > 1500 && (
                    <FormControlLabel
                      value="208V, 2P"
                      control={<Radio />}
                      label="208V, 2P"
                    />
                  )}
                  {this.props.totalcap > 1500 && (
                    <FormControlLabel
                      value="240V, 2P"
                      control={<Radio />}
                      label="240V, 2P"
                    />
                  )}

                  <FormControlLabel
                    value="277V, 1P"
                    control={<Radio />}
                    label="277V, 1P"
                  />
                  {this.props.totalcap > 1500 && (
                    <FormControlLabel
                      value="120V / 240V"
                      control={<Radio />}
                      label="120V / 240V"
                    />
                  )}
                  {this.props.totalcap > 1500 && (
                    <FormControlLabel
                      value="120V / 277V"
                      control={<Radio />}
                      label="120V / 277V"
                    />
                  )}
                  {this.props.totalcap > 1500 && (
                    <FormControlLabel
                      value="277V / 480V"
                      control={<Radio />}
                      label="277V / 480V"
                    />
                  )}
                  {this.props.totalcap > 1500 && (
                    <FormControlLabel
                    
                      value="120V / 240V / 277V"
                      control={<Radio />}
                      label="120V / 240V / 277V"
                    />
                  )}
                </RadioGroup>
              </FormControl>
            </Paper>
          )}
          {!this.props.data.threePhase && (
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">
                Note: The higher the voltage the smaller the wires and will be
                more cost effective to wire.
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                onChange={this.saveOVData}
                defaultValue={this.state.outVoltData}
                sx={{ '& .MuiTypography-root': { fontFamily: 'Ford-Normal' } }}
              >
                <FormControlLabel
                  value="208Y/120"
                  control={<Radio />}
                  label="208Y/120"
                />
                <FormControlLabel
                  value="480Y/277"
                  control={<Radio />}
                  label="480Y/277"
                />
              </RadioGroup>
            </FormControl>
          )}
        </CardContent>
        {/* <NavRow next={this.props.next} previous={this.props.previous} showNextButton={showNextButton} showPrevButton={true}/> */}
      </Card>
    );
  }
}

export default OutputVoltageView;
